import React, { forwardRef, useState, useEffect } from 'react';
import webServices from '../../services/webServices';

import AppConstants from '../../appConstants';

import approvedIcon from '../../adminAssets/images/approved-big.svg';
import pendingIcon from '../../adminAssets/images/pending-big.svg';
import rejectedIcon from '../../adminAssets/images/rejected-big.svg';
import deletedIcon from '../../adminAssets/images/Delete-big.svg';

const AffiliatePaymentSummaryComponent = forwardRef(() => {
  const [dataObj, setDataObj] = useState({
    affiliates: {
      total: 0,
      approved: 0,
      pending: 0,
      rejected: 0,
      deleted: 0,
    },
    payments: {
      upcoming: 0,
      overdue: 0,
      total_sale: 0,
      total_commission: 0
    }
  });

  useEffect(async () => {
    const result = await webServices.getAffiliateSummary();
    if (result.success === true && result.data) {
      setDataObj(result.data);
    }
  }, []);

  return (
    <div className="container-fluid right">
      <header>
        <div className="bakdrum">
          <a href="/">Admin /</a> <span>Dashboard</span>
        </div>
        <div className="d-flex header-right" />
      </header>
      <div className="mainBody_container">
        <div className="row">
          <div className="col-12">
            <div className="title">
              <h2 className="mb-0">Total Affiliates</h2>
              <div className="d-flex align-items-center">
                <h3 className="mb-0">{dataObj.affiliates.total}</h3>
                <a href={AppConstants.routes.admin.affiliate.all_profiles} className="view_all" role="button">View All <i className="fa fa-arrow-right ml-2" aria-hidden="true" /></a>
              </div>
            </div>
          </div>
        </div>

        <div className="row affiliate_box_wrapper">
          <div className="col-md-6">
            <div className="aff_dashbaord_box">
              <img src={approvedIcon} alt="" />
              <div className="sub_title">APPROVED Affiliate</div>
              <h4>{dataObj.affiliates.approved}</h4>
            </div>
          </div>

          <div className="col-md-6">
            <div className="aff_dashbaord_box">
              <img src={pendingIcon} alt="" />
              <div className="sub_title">pending Affiliate</div>
              <h4>{dataObj.affiliates.pending}</h4>
            </div>
          </div>

          <div className="col-md-6">
            <div className="aff_dashbaord_box">
              <img src={rejectedIcon} alt="" />
              <div className="sub_title">Rejected Affiliate</div>
              <h4>{dataObj.affiliates.rejected}</h4>
            </div>
          </div>

          <div className="col-md-6">
            <div className="aff_dashbaord_box">
              <img src={deletedIcon} alt="" />
              <div className="sub_title">Deleted Affiliate</div>
              <h4>{dataObj.affiliates.deleted}</h4>
            </div>
          </div>
        </div>

        <div className="row affiliate_counter">
          <div className="col-md-12 col-lg-6 mt-lg-0 mt-4">
            <div className="counter_box">
              <h4>PAYOUTS & TRANSACTIONS</h4>
              <div className="row">
                <div className="col-md-6 col-sm-6">
                  <h5>{dataObj.payments.upcoming}</h5>
                  <div className="caption">Upcoming </div>
                  <a href={AppConstants.routes.admin.affiliate.payments.upcoming} className="arrow_btn"><i className="fa fa-arrow-right" aria-hidden="true" /> </a>
                </div>
                <div className="col-md-6 col-sm-6">
                  <h5>{dataObj.payments.overdue}</h5>
                  <div className="caption">Overdue </div>
                  <a href={AppConstants.routes.admin.affiliate.payments.overdue} className="arrow_btn"><i className="fa fa-arrow-right" aria-hidden="true" /> </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-6 mt-lg-0 mt-4">
            <div className="counter_box">
              <h4>OVERVIEW</h4>
              <div className="row">
                <div className="col-md-6 col-sm-6">
                  <h5>${dataObj.payments.total_sale}</h5>
                  <div className="caption">Total Sales Revenue </div>
                  <a href className="arrow_btn"><i className="fa fa-arrow-right" aria-hidden="true" /> </a>
                </div>
                <div className="col-md-6 col-sm-6">
                  <h5>${dataObj.payments.total_commission}</h5>
                  <div className="caption">Total Commission </div>
                  <a href className="arrow_btn"><i className="fa fa-arrow-right" aria-hidden="true" /> </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default AffiliatePaymentSummaryComponent;
